export default __webpack_public_path__ + "static/media/contactus_organisme.e93367d2.png";